import { useState } from "react";
import { Compass, Plus } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";

import { ExploreSections } from "@/components/Explore";
import { ContentLayout } from "@/layout";
import { MODAL_ROUTES, ROUTES } from "@/router";
import { useNavigateModal } from "@/router/useNavigateModal";
import { useUserStore } from "@/stores";
import type { Tab } from "@/ui";
import { Breadcrumb, Button, Heading, SectionHeader, Tabs } from "@/ui";

// Main admin screen for managing Explore sections (News & Blog, Research, etc.)
// This lets admins create and edit the cards that appear in the mobile app's Explore tab
export const Explore = () => {
  const navigate = useNavigate();
  const navigateModal = useNavigateModal();
  const { user } = useUserStore();

  // Only show the sections tab for now (can add more tabs later if needed)
  const tabs: [Tab, ...Tab[]] = [
    {
      component: <ExploreSections />,
      label: "Sections",
      roles: ["admin"],
    },
  ];

  const [currentTabLabel, setCurrentTabLabel] = useState(tabs[0].label);

  const breadcrumbItems = [
    {
      label: "Explore",
      href: ROUTES.explore,
      icon: <Compass />,
    },
  ];

  return (
    <ContentLayout className="flex flex-col gap-y-6">
      <Breadcrumb
        items={breadcrumbItems}
        current="Explore"
        onItemClick={(item) => {
          if (item.href) {
            navigate(item.href);
          }
        }}
      />
      <SectionHeader
        left={
          <Heading level={2} heading="Explore Sections" className="text-3xl" />
        }
        right={
          <Button
            size="md"
            onClick={() => navigateModal(MODAL_ROUTES.addExploreSection)}
            className="min-w-36"
          >
            <Plus size={20} />
            New Section
          </Button>
        }
      />
      <Tabs
        tabs={tabs}
        userRole={user?.role ?? "loggedOut"}
        currentLabel={currentTabLabel}
        setCurrentLabel={setCurrentTabLabel}
      />
    </ContentLayout>
  );
};
